import type { CriarCustoAquisicaoDto, ImpactoCascataResumo, PreviaEscolhidaDto } from '@triade/contracts';
import { useMutacao } from './base';

/**
 * Previa de impacto em cascata (Sessao 49, F): POST sem efeito colateral. A API grava numa transacao descartada e devolve
 * o resumo; nada e invalidado aqui (nada mudou de verdade). A gravacao continua sendo a rota de sempre, depois da confirmacao.
 */

/** Nova aquisicao: mesmo corpo de POST /custos-aquisicao (`custoAquisicao.editar`). */
export function usePreviaImpactoAquisicao() {
  return useMutacao<ImpactoCascataResumo, CriarCustoAquisicaoDto>({
    metodo: 'POST',
    caminho: () => '/impacto-cascata/aquisicao',
    corpo: (v) => v,
  });
}

/** Troca da ficha escolhida do item: mesmo corpo de PATCH /fichas-tecnicas/:id/escolhida + `fichaId` (`ficha.editar`). */
export function usePreviaImpactoEscolhida() {
  return useMutacao<ImpactoCascataResumo, PreviaEscolhidaDto>({
    metodo: 'POST',
    caminho: () => '/impacto-cascata/ficha-escolhida',
    corpo: (v) => v,
  });
}
